<form nz-form [formGroup]="formGroup">
    <div id="eform-modal-body" innerHTML="{{body}}">
    </div>
</form>
<div *nzModalFooter>
    <button class="btn btn-back" title="Trở lại" (click)="close()">
        <span nz-icon nzType="reload"></span> Trở lại
    </button>
</div>